import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useParams } from 'react-router'

// Store
import { actions } from 'core/store'

// Hooks
// import { useLocalStorage } from 'core/hooks/storage'
import { useGetAddresses } from 'core/hooks/api'

// Styled Elements
import { TableWrapper } from './AccountAddressesTable.elements'

// Views
import { AccordionTable, EmptyTablePlaceholder, LoadingTablePlaceholder } from 'views/components'

import AddressesTableItem from '../../../../BlockchainAnalytics/Addresses/AddressesTableItem'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions
function AccountAddressesTable(props) {
  // Destructure
  const { filters, ui, actions, address } = props
  const { account_id } = useParams()

  // Store States
  const { addressFilters } = filters
  const { scannedAddress } = address
  const { isPageTableUpdated } = ui
  const { setIsPageTableUpdated, setAddressFilters, showAlert, setScannedAddress, setScannedAddressDetails } = actions

  // Hooks
  const { getAddresses, getAddressesData, getAddressesError, isGetAddressesLoading } = useGetAddresses()

  // Local states
  const [addresses, setAddresses] = useState([])
  const [pagination, setPagination] = useState()
  const [openedTab, setOpenedTab] = useState()

  // Functions
  function handleScannedAddress() {
    const newAddress = {
      id: scannedAddress?.address_id,
      address: scannedAddress?.address,
      chain: scannedAddress?.chain,
      symbol: scannedAddress?.symbol,
      risk_score: scannedAddress?.risk_data?.risk_score,
      risk_ratio: scannedAddress?.risk_data?.risk_ratio,
      balance_usd: scannedAddress?.financial_data?.balance_usd,
      balance: scannedAddress?.financial_data?.balance,
      modify_tz: scannedAddress?.request_tz,
      link_id: scannedAddress?.link_id,
      link_type: scannedAddress?.link_type,
      is_self_hosted: scannedAddress?.is_self_hosted,
      modified_by_name: scannedAddress?.modified_by_name,
    }
    const newAddressList = [newAddress]
    addresses.forEach((item) => {
      if (item.address !== scannedAddress.address) {
        newAddressList.push(item)
      }
    })
    // Changing it back to null
    setScannedAddress(null)
    setAddresses(newAddressList)
    setScannedAddressDetails(scannedAddress)
  }

  // UseEffects
  useEffect(() => {
    if (isPageTableUpdated) {
      getAddresses({ ...addressFilters, link_id: account_id })
      setIsPageTableUpdated(false)
    } else if (addressFilters) {
      getAddresses({ ...addressFilters, link_id: account_id })
    }
  }, [isPageTableUpdated, addressFilters])
  useEffect(() => {
    if (getAddressesData) {
      setAddresses(getAddressesData.items)
      setPagination(getAddressesData.pagination)
    }
  }, [getAddressesData])
  useEffect(() => {
    // TODO ADD PROPER ERROR MSG SENT FROM SERVER
    if (getAddressesError) showAlert({ type: 'error', message: 'An error occurred in fetching addresses' })
  }, [getAddressesError])
  useEffect(() => {
    // TODO ADD PROPER ERROR MSG SENT FROM SERVER
    if (scannedAddress) handleScannedAddress()
  }, [scannedAddress])

  return (
    <TableWrapper>
      <AccordionTable
        totalItems={pagination?.total && pagination.total}
        minWidth={900}
        tableFilters={addressFilters}
        setTableFilters={setAddressFilters}
      >
        {addresses.length > 0 &&
          !isGetAddressesLoading &&
          addresses.map((data) => (
            <AddressesTableItem
              openedTab={openedTab}
              setOpenedTab={setOpenedTab}
              key={`${data.id}${data.address}`}
              data={data}
              getAddressesError={getAddressesError}
            />
          ))}
        {isGetAddressesLoading && <LoadingTablePlaceholder />}
        {(addresses?.length < 1 || !addresses) && !isGetAddressesLoading && (
          <EmptyTablePlaceholder setFilter={() => setAddressFilters({ link_id: account_id })} />
        )}
      </AccordionTable>
    </TableWrapper>
  )
}

// Default Props
AccountAddressesTable.defaultProps = {
  actions: {},
  filters: {},
  ui: {},
}

// Proptypes Validation
AccountAddressesTable.propTypes = {
  filters: PropTypes.shape({
    addressFilters: PropTypes.instanceOf(Object),
  }),
  ui: PropTypes.shape({
    isPageTableUpdated: PropTypes.bool,
  }),
  actions: PropTypes.shape({
    setToBeUpdatedAccount: PropTypes.func,
    setAccountDirectoryFilters: PropTypes.func,
    setIsIndividualAccountDrawerOpen: PropTypes.func,
    setIsEntityAccountDrawerOpen: PropTypes.func,
    setShowHeaderLoader: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
    setAddressFilters: PropTypes.func,
    showAlert: PropTypes.func,
    setScannedAddress: PropTypes.func,
    setScannedAddressDetails: PropTypes.func,
  }),
  address: PropTypes.shape({
    scannedAddress: PropTypes.shape({
      address_id: PropTypes.string,
      address: PropTypes.string,
      chain: PropTypes.string,
      symbol: PropTypes.string,
      symbol_icon: PropTypes.string,
      financial_data: PropTypes.shape({
        provider_name: PropTypes.string,
        balance: PropTypes.number,
        balance_usd: PropTypes.number,
        spent: PropTypes.number,
        spent_usd: PropTypes.number,
        received: PropTypes.number,
        received_usd: PropTypes.number,
        transaction_count: PropTypes.number,
        latest_activity: PropTypes.string,
      }),
      risk_data: PropTypes.shape({
        provider_name: PropTypes.string,
        risk_score: PropTypes.number,
        risk_ratio: PropTypes.number,
        vasp_name_legal: PropTypes.string,
        vasp_name_business: PropTypes.string,
        vasp_website: PropTypes.string,
        vasp_category: PropTypes.string,
        api_result_id: PropTypes.string,
      }),
      request_tz: PropTypes.string,
      modified_by_name: PropTypes.string,
      link_id: PropTypes.string,
      link_type: PropTypes.number,
      is_self_hosted: PropTypes.bool,
    }),
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountAddressesTable)
